import React from 'react';
import './Icon.scss';
const rootClassName = 'icon-component';

export const CalendarCheckIcon = () => {
  return (
    <svg
      className={rootClassName}
      viewBox='0 0 24 24'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8 5.00288V6.51115C8 6.78113 7.77614 7 7.5 7C7.22386 7 7 6.78113 7 6.51115V5.00288H3.3002C3.13434 5.00288 3.0002 5.13745 3.0002 5.30383V9.9997H21.0002V5.30383C21.0002 5.13789 20.8655 5.00288 20.7002 5.00288H17V6.51115C17 6.78113 16.7761 7 16.5 7C16.2239 7 16 6.78113 16 6.51115V5.00288H12.5V6.51115C12.5 6.78113 12.2761 7 12 7C11.7239 7 11.5 6.78113 11.5 6.51115V5.00288H8ZM2.0002 20.6956V10.514L2 10.4997L2.0002 10.4854V5.30383C2.0002 4.58341 2.58206 3.9997 3.3002 3.9997H7V2.48885C7 2.21887 7.22386 2 7.5 2C7.77614 2 8 2.21887 8 2.48885V3.9997H11.5V2.48885C11.5 2.21887 11.7239 2 12 2C12.2761 2 12.5 2.21887 12.5 2.48885V3.9997H16V2.48885C16 2.21887 16.2239 2 16.5 2C16.7761 2 17 2.21887 17 2.48885V3.9997H20.7002C21.4176 3.9997 22.0002 4.58366 22.0002 5.30383V20.6956C22.0002 21.4157 21.4176 21.9997 20.7002 21.9997H3.3002C2.58206 21.9997 2.0002 21.416 2.0002 20.6956ZM21.0002 10.9997H3.0002V20.6956C3.0002 20.862 3.13434 20.9965 3.3002 20.9965H20.7002C20.8655 20.9965 21.0002 20.8615 21.0002 20.6956V10.9997ZM13.1438 14.821C13.3355 14.6258 13.6461 14.6259 13.8377 14.8213L15.1095 16.1181L17.6401 13.1705C17.8185 12.9626 18.1285 12.9416 18.3324 13.1234C18.5364 13.3052 18.557 13.6211 18.3786 13.8289L15.5025 17.1789C15.3156 17.3967 14.9869 17.4078 14.7862 17.2032L13.1436 15.5282C12.9521 15.3328 12.9521 15.0163 13.1438 14.821Z'
      />
    </svg>
  );
};
